const APP = '/app';
const API = `${APP}/api`;
const USERS = `${APP}/users`;
const WALLET = `${API}/wallet`;

export const routes = {
  root: '/',
  terms: '/terms',
  privacy: '/privacy',
  app: {
    root: `${APP}/`,
    signin: `${APP}/signin`,
    signup: `${APP}/signup`,
    settings: `${APP}/settings`,
    passwordReset: `${APP}/user/password-reset`,
    passwordResetConfirm: (token: string) => `${APP}/user/password-reset/${token}`,
    emailVerificationConfirm: (token: string) => `${APP}/user/verify-email/${token}`,
  },
  auth: {
    session: `${USERS}/session`,
    signUp: `${USERS}/sign_up`,
    signUpWithOAuth: `${USERS}/sign_up/with_oauth`,
    signOut: `${USERS}/sign_out`,
    emailVerification: `${USERS}/email_verification`,
    emailVerificationResend: `${USERS}/email_verification/resend`,
    passwordReset: `${USERS}/password_reset`,
    password: `${USERS}/password`,
    oauthRequest: (provider: string) => `${USERS}/oauth/${provider}`,
  },
} as const;

export const apiRoutes = {
  me: `${API}/me`,
  adClicks: `${API}/ad_clicks`,
  tenant: `${API}/tenant`,
  countries: `${API}/countries`,
  oauthPending: `${USERS}/oauth/pending`,
  facilities: `${API}/facilities`,
  accounts: `${API}/accounts`,
  account: (id: number | string) => `${API}/accounts/${id}`,
  schedules: `${API}/schedules`,
  schedulePause: (id: number | string) => `${API}/schedules/${id}/pause`,
  scheduleActivate: (id: number | string) => `${API}/schedules/${id}/activate`,
  scheduleReactivation: (id: number | string) => `${API}/schedules/${id}/reactivation`,
  schedulePreferences: (id: number | string) => `${API}/schedules/${id}/preferences`,
  scheduleActivities: (id: number | string) => `${API}/schedules/${id}/activities`,
  statsDateHistory: `${API}/stats/date_history`,
  plan: `${API}/plan`,
  visaPreparation: `${API}/visa/preparation`,
  visaConsultingRequest: `${API}/visa/consulting-request`,
  wallet: {
    mercadopagoPayments: `${WALLET}/mercadopago/payments`,
    stripePayments: `${WALLET}/stripe/payments`,
    transactions: `${WALLET}/transactions`,
    transaction: (id: number | string) => `${WALLET}/transactions/${id}`,
  },
} as const;
